import * as React from "react";
import type { SVGProps } from "react";
const SvgInfocenterLink = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 23" {...props}>
        <path
            fill="currentColor"
            d="M7.012 5.273H2.07v7.707c0 .266-.218.48-.488.48a.49.49 0 0 1-.492-.48V4.313h5.953c1.246 0 2.172-.004 2.922.16.746.16 1.316.476 1.898 1.039.633-.59 1.399-.89 2.266-1.04.918-.16 1.992-.156 3.18-.156h5.332l.004 13.414h-5.348c-1.2-.003-2.176-.003-2.996.137-.887.153-1.54.461-2.051 1.094a.49.49 0 0 1-.371.184.5.5 0 0 1-.383-.165c-.617-.699-1.09-.98-1.734-1.117-.633-.136-1.426-.136-2.696-.133H1.09V15.38c0-.266.222-.48.492-.48s.488.214.488.48v1.394h4.516q.259-.002.5-.003c1.226 0 2.14-.004 2.883.156.535.113.984.312 1.41.62V6.399c-.566-.601-1.02-.859-1.625-.992-.637-.136-1.445-.136-2.742-.133m5.343 1.114v11.187c.528-.344 1.122-.539 1.778-.652.91-.156 1.976-.152 3.156-.152q.21.004.426.003h3.95V5.277H17.32c-1.21-.004-2.195-.004-3.02.141-.827.14-1.452.422-1.945.969M5.988 9.105v-.957h.98v.957Zm14.207 0h-5.879v-.957h5.88ZM5.988 13.898v-3.835h.98v3.835ZM20.195 11.5h-5.879v-.957h5.88Zm0 2.398h-5.879v-.96h5.88Zm0 0"
            style={{
                stroke: "none",
                fillRule: "evenodd",
                fillOpacity: 1,
            }}
        />
    </svg>
);
export default SvgInfocenterLink;
